import { Table } from "antd";

export default function InspectorStats(props) {
  return (
    <div>
      <Table columns={props.columns} dataSource={props.data} key={props.key} size="middle" />
    </div>
  );
}
